{
  "version": 1,
  "asset_id": "d156fe55-1250-4163-b7a2-d322a0af59be",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d156fe55-1250-4163-b7a2-d322a0af59be/bypass-revision-downsizing-en-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d156fe55-1250-4163-b7a2-d322a0af59be/bypass-revision-downsizing-en-320.webp",
  "original_filename": "bypass-revision-downsizing-en-320.webp",
  "size": 15660,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:41Z"
}
